module.exports = __webpack_public_path__ + "static/media/sector-6.12a9d870.jpg";